/**
 * Returns an object with informations about the parent window
 * - parent: boolean (parent window exists)
 * - intro:  (div#sk_4g_intro exists)
 * - p1:  (div#sk_4g_p1 exists) =>
 * - p2:  (div#sk_4g_p2 exists) => bisherige Auswahl
 * - p3:  (div#sk_4g_p3) => Gesamtpreis
 * - message:  ()
 * @returns {boolean|{parent: boolean, p1: boolean, p2: boolean, p3: boolean, intro: boolean, message: boolean}}
 */
function detectClientContext() {
  let retObj = {
    parent: checkForParentContainer(),
    intro: 'sk_4g_intro',
    p1: 'sk_4g_p1',
    p2: 'sk_4g_p2',
    p3: 'sk_4g_p3',
    message: 'sk_4g_message'
  };
  return retObj;
}

/**
 * Checks if the app is included in the appcontainer of the cms
 */
function checkForParentContainer(){
  let check = window.location.search.substring(1);
  // console.log("Check = " + check);
  if(check == 'check=1') return true;
  return false;
}



export default detectClientContext();
